import NoticeConfiguration from './NoticeConfiguration';

export default (props) => {
  return <NoticeConfiguration {...props} />;
};
